import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MENU } from '../../utils/constants';
import Logo from '../Logo/Logo';
import Socials from '../Socials/Socials';
import { motion, AnimatePresence } from 'framer-motion';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Animation variants
  const menuVariants = {
    hidden: { 
      opacity: 0,
      y: -20,
      transition: {
        staggerChildren: 0.05,
        staggerDirection: -1
      } 
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        staggerChildren: 0.07,
        delayChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: -20 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { type: "spring", stiffness: 300, damping: 24 }
    }
  };

  return (
    <section className="header">
      <div className="container">
        <motion.header
          initial={{ y: -50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
        >
          <Logo />
          <AnimatePresence>
            {isMenuOpen && (
              <motion.nav 
                className={`menu active`}
                variants={menuVariants}
                initial="hidden"
                animate="visible"
                exit="hidden"
              >
                {MENU.map(({ link, name }, i) => (
                  <motion.div 
                    key={link} 
                    className="menu-item"
                    variants={itemVariants}
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    <Link to={`/${link}`} onClick={() => setIsMenuOpen(false)}>
                      {name}
                    </Link>
                  </motion.div>
                ))}
              </motion.nav>
            )}
          </AnimatePresence>
          
          <nav className={`menu desktop-menu ${isMenuOpen ? 'active' : ''}`}>
            {MENU.map(({ link, name }, i) => (
              <motion.div 
                key={link} 
                className="menu-item"
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.1, duration: 0.5 }}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.95 }}
              >
                <Link to={`/${link}`} onClick={() => setIsMenuOpen(false)}>
                  {name}
                </Link>
              </motion.div>
            ))}
          </nav>
          
          <Socials />
          <motion.div 
            className={`burger ${isMenuOpen ? 'active' : ''}`} 
            onClick={toggleMenu}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            <span></span>
            <span></span>
            <span></span>
          </motion.div>
        </motion.header>
      </div>
    </section>
  );
};

export default Header;